<template>
    <layout title="Board Notes">
        <settings-layout>
            <div class="max-w-3xl mx-12 pb-8 flex items-center justify-between">
                <div class="flex items-center">
                    <h1 v-if="! editTitle" class="text-2xl font-medium text-blue-800">{{ note.title }}</h1>
                    <svg v-if="! editTitle" @click="editTitle = true" class="w-5 h-5 ml-2 text-blue-500 cursor-pointer hover:text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
                    <text-input v-if="editTitle" v-model="note.title"  class="p-1 text-sm" />
                    <button v-if="editTitle" @click="saveNoteTitle()" type="button" class="flex items-center justify-center py-3 px-4 border border-transparent shadow-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700">
                        <span>Save</span>
                    </button>
                </div>
                <div class="flex items-center justify-end">
                    <remove-board-note :item="note"></remove-board-note>
                </div>

            </div>
            <ol class="max-w-3xl mx-12">
                <draggable v-model="sortedNotes" handle=".item-number" :group="{ name: 'notes' }" @end="updateParentOrder">
                    <li v-for="(note, index) in sortedNotes" class="border-b-2 border-gray-100 ">
                        <div class="note-item">
                            <note-item
                                type="parent"
                                :index="index"
                                :note="note"
                                @updateNote="updateNotes()"
                                v-on:make-child="makeChild(note, index)">
                            </note-item>
                        </div>
                        <ol class="divide-y">
                            <draggable v-model="note.children" handle=".item-number" :group="{ name: 'children' }" @end="updateChildOrder">
                                <li v-for="(childNote, idx) in note.children" class="border-t-2 border-gray-100 ">
                                    <div class="child-note-item flex items-center justify-between">
                                        <note-item
                                            type="child"
                                            :parent="note"
                                            :index="idx"
                                            :note="childNote"
                                            @updateNote="updateNotes()"
                                            v-on:make-parent="makeParent(childNote, idx)">
                                        </note-item>
                                    </div>
                                </li>
                            </draggable>
                        </ol>
                    </li>
                </draggable>
                <add-note-item :board-note="note.id"></add-note-item>
            </ol>
        </settings-layout>
    </layout>
</template>

<script>
import Layout from "@/Shared/Layout";
import SettingsLayout from "../SettingsLayout";
import draggable from 'vuedraggable'
import NoteItem from "@/Components/BoardNotes/NoteItem";
import AddNoteItem from "@/Components/BoardNotes/AddNoteItem";
import TextInput from "@/Shared/TextInput";
import RemoveBoardNote from "../../../Components/BoardNotes/RemoveBoardNote";

export default {
    components: {RemoveBoardNote, TextInput, AddNoteItem, NoteItem, SettingsLayout, Layout, draggable},
    props: {
        note: {
            type: Object
        }
    },
    data() {
        return {
            sortedNotes: this.noteItems,
            editTitle: false,
        }
    },
    methods: {
        makeParent(note, index) {
            let parent = this.sortedNotes.findIndex(sortedNote => note.parent_id === sortedNote.id)
            this.sortedNotes[parent].children.splice(index, 1)
            note.parent_id = null
            this.sortedNotes.splice(parent, 0, note)
            this.updateParentOrder()
        },
        makeChild(note, index) {
            this.sortedNotes.splice(index, 1)
            let newParent = this.sortedNotes[this.sortedNotes.length-1]
            newParent.children.push(note)
            note.parent_id = newParent.parent_id
            this.updateChildOrder(newParent)
        },
        updateParentOrder() {
            this.sortedNotes.map((note, index) => note.order = index)
            this.updateNotes()
        },
        updateNotes() {
            this.$inertia.put(this.route('settings.board-notes.update', this.note.id), {
                title: this.note.title,
                noteItems: this.sortedNotes
            })
        },
        updateChildOrder() {
            this.sortedNotes.map((note, index) => {
                if (note.children) {
                    note.children.map((child, childIndex) => {
                        child.order = childIndex
                        child.parent_id = note.id
                    })
                }
            })
            this.updateParentOrder()
        },
        saveNoteTitle() {
            this.updateNotes()
            this.editTitle = false
        }
    },
    mounted() {
        this.sortedNotes = this.note.note_items
        this.updateChildOrder()
    }
}
</script>

